<div class="profile-page-container">
  <div *ngIf="loadingProfile" class="loading-state">
    <div class="spinner"></div>
    <p>Loading profile details...</p>
  </div>

  <div *ngIf="!loadingProfile && user" class="profile-card">
    
    <div class="profile-header">
        <button class="back-btn" (click)="goBack()">
        <span class="menu-icon">⬅️</span>
        <span class="menu-label">Back</span>
      </button>
      <div class="profile-avatar">
        {{ user.displayName ? user.displayName.charAt(0) : user.email.charAt(0) | uppercase }}
      </div>
      <h2>{{ user.displayName || 'User Profile' }}</h2>
      <p class="profile-role">{{ user.role | titlecase }}</p>
    </div>

    <div class="profile-details-section">
      <h3>Basic Information</h3>
      <div class="detail-item">
        <span class="detail-label">Full Name:</span>
        <span class="detail-value">{{ user.displayName || 'N/A' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Email:</span>
        <span class="detail-value">{{ user.email || 'N/A' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">User ID:</span>
        <span class="detail-value">{{ user.uid || 'N/A' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Role:</span>
        <span class="detail-value">{{ user.role || 'N/A' }}</span>
      </div>
    </div>

    <!-- Add more sections as needed -->
    <!--
    <div class="profile-details-section">
      <h3>Contact Information</h3>
      <div class="detail-item">
        <span class="detail-label">Phone:</span>
        <span class="detail-value">+123 456 7890</span>
      </div>
    </div>
    -->
  </div>

  <div *ngIf="!loadingProfile && !user" class="no-profile-data">
    <p>No user profile data available.</p>
    <p>Please ensure you are logged in.</p>
  </div>
</div>